module.exports = __webpack_public_path__ + "static/media/Icono empleados.331aecee.svg";